import React from 'react';
import InputSelect from '@components/ringil3/Input/InputSelect/InputSelect.tsx';
import useTranslationLgs from '@hooks/i18n/useTranslation';

interface ComponentProps {
  value?: boolean;
  onChange: (value: boolean) => void;
  yesLabel?: string;
  noLabel?: string;
  disabled?: boolean;
  dataTestId?: string;
}

const YES = 'yes';
const NO = 'no';

const InputYesNo: React.FC<ComponentProps> = ({ value, onChange, yesLabel, noLabel, disabled, dataTestId }) => {
  const { tr } = useTranslationLgs();

  const model = [
    { code: YES, label: yesLabel ?? tr('generic.yes', 'Yes') },
    { code: NO, label: noLabel ?? tr('generic.no', 'No') },
  ];

  return (
    <InputSelect
      model={model}
      selectedItemCode={value === true ? YES : value === false ? NO : undefined}
      onSelect={code => onChange(code === YES)}
      disabled={disabled}
      dataTestIdPrefix={dataTestId}
    />
  );
};

export default InputYesNo;
